export const customerSectionLabels = {
  route: {
    coverage: "도시권 기준 직항",
    detail: "노선부터 도착 첫 길까지",
    schedule: "확인된 출발편",
    arrival: "내린 뒤 첫 길"
  },
  edition: {
    eat: "도착해서 먹을 것",
    budget: "하루 예산",
    bringHome: "이 도시에서 가져올 것",
    walkFurther: "첫 동네 다음",
    correction: "달라진 시간표 제보",
    savedCards: "이 기기에 저장한 첫 길",
    savedCard: "저장한 도착 첫 길"
  },
  cityGuide: {
    actualMap: "실제 지도",
    transport: "공항에서 숙소까지",
    stay: "숙소 권역 고르기",
    duration: "여행 일수 고르기",
    localPicks: "순위보다 지금 있는 동네",
    nearby: "근교 붙이기",
    sources: "공식 원문 다시 확인"
  },
  trip: {
    create: "새 여행 만들기",
    overview: "이번 여행 현황",
    itinerary: "날짜별 일정",
    prepare: "출발 전 준비",
    officialTools: "공식 안내 바로가기",
    budget: "여행 예산",
    fareNotes: "내가 본 항공권 가격",
    keep: "여행 보관하기",
    today: "인터넷 없이 보는 오늘 여행",
    todayPlan: "오늘 일정",
    emergency: "긴급 연락",
    phrases: "바로 보여줄 일본어",
    liveCheck: "지금 공식 정보 확인"
  },
  film: {
    view: "골목 필름 보기",
    addScene: "여행 장면 더하기",
    keep: "골목 필름 보관하기",
    file: "나만의 골목 필름 · 이 기기에서 만든 파일"
  },
  correction: "달라진 정보 제보"
} as const;

export function tripDayIdeaLabel(day: number) {
  return `${day}일차 추천`;
}

export function tripDayLabel(day: number) {
  return `${day}일차`;
}

export const legalSectionLabels = {
  privacy: "개인정보 안내",
  terms: "이용 안내",
  support: "문의 안내"
} as const;

export type AutomationStatus = {
  state: string;
  providers: { provider: string; status: string; checkedAt: string | null; errorCode: string | null }[];
};

const automationProviderCopy: Record<string, string> = {
  kac: "한국공항공사 운항",
  icn: "인천공항 운항",
  access: "공항 이동 안내"
};

const automationRunCopy: Record<string, string> = {
  succeeded: "최근 확인 완료",
  quarantined: "변경 내용 확인 필요",
  failed: "최근 확인 실패",
  not_run: "아직 자동 확인 전",
  unknown: "확인 상태를 읽지 못함"
};

const isRecord = (value: unknown): value is Record<string, unknown> => Boolean(value && typeof value === "object");

export function readAutomationStatus(payload: unknown): AutomationStatus {
  const record = isRecord(payload) ? payload : {};
  const providers = Array.isArray(record.providers)
    ? record.providers.flatMap((value) => {
      if (!isRecord(value)) return [];
      return [{
        provider: typeof value.provider === "string" ? value.provider : "unknown",
        status: typeof value.status === "string" ? value.status : "unknown",
        checkedAt: typeof value.checkedAt === "string" ? value.checkedAt : null,
        errorCode: typeof value.errorCode === "string" ? value.errorCode : null
      }];
    })
    : [];
  return {
    state: typeof record.state === "string" ? record.state : "unavailable",
    providers
  };
}

export function automationHeadline(automation: AutomationStatus | null) {
  if (automation === null) return "확인 중";
  const statuses = automation.providers.map((item) => item.status);
  if (statuses.includes("quarantined")) return "변경 내용 확인 필요";
  if (statuses.some((status) => status === "failed" || status === "unknown")) return "일부 정보를 확인하지 못함";
  if (statuses.length > 0 && statuses.every((status) => status === "succeeded")) return "최근 자동 확인 완료";
  if (statuses.includes("succeeded")) return "일부 자동 확인 완료";
  if (automation.state === "observable") return "아직 자동 확인 전";
  return "자동 확인 상태를 불러오지 못함";
}

export function automationSummary(automation: AutomationStatus | null) {
  if (automation === null) return "확인 기록을 불러오는 중이에요";
  if (automation.providers.length === 0) return "자동 확인 기록을 불러오지 못했어요";
  return automation.providers.map((item) => {
    const provider = automationProviderCopy[item.provider] ?? "공식 정보";
    const status = automationRunCopy[item.status] ?? "확인 상태를 읽지 못함";
    return `${provider} · ${status}`;
  }).join(" / ");
}
